/* eslint-disable eqeqeq */
import React from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@material-ui/core";
import moment from "moment";
import ReactHtmlParser from "react-html-parser";
import { numberToStringVN } from "../../../services/libService";
import { useTranslation } from "react-i18next";
import { Button, Checkbox } from "@mui/material";

/** function */
import { sumOfField } from "../../../services/libService";

export default function FormPNForAirport({ data = "", onCheckbox, onCheckAll }) {
  const [t] = useTranslation();
  const totalTotal = data?.ciproducts.filter((i) => i.isCreateBK !== false).reduce((p, c) => p + +c.total, 0);
  const renderUpLift = (id, ciProduct, invDetails) => {
    return (
      <div style={{ textAlign: "left", marginLeft: "30px", marginTop: "50px" }} key={id}>
        <div>
          {id}.{ciProduct.location}-{ciProduct.de_type}/{t(ciProduct?.saletype, { lng: "vi" })}
        </div>
        <div style={{ marginTop: "30px" }}>
          <Table style={{ pageBreakInside: "auto" }}>
            <TableHead>
              <TableRow>
                <TableCell style={{ padding: 3, border: "1px solid gray" }} align="center" rowSpan={2}>
                  {"STT"}
                </TableCell>
                <TableCell style={{ padding: 3, border: "1px solid gray" }} align="center" rowSpan={2}>
                  {"Ngày"}
                </TableCell>
                <TableCell style={{ padding: 3, border: "1px solid gray" }} align="center" rowSpan={2}>
                  {"Số HĐ"}
                </TableCell>
                <TableCell style={{ padding: 3, border: "1px solid gray" }} align="center" rowSpan={2}>
                  {"Số phiếu GN"}
                </TableCell>
                {data.loadingtype_id == 1 && (
                  <>
                    <TableCell style={{ padding: 3, border: "1px solid gray" }} align="center" rowSpan={2}>
                      {"Đăng bạ tàu bay"}
                    </TableCell>
                    <TableCell style={{ padding: 3, border: "1px solid gray" }} align="center" rowSpan={2}>
                      {"Tuyến bay"}
                    </TableCell>
                    <TableCell style={{ padding: 3, border: "1px solid gray" }} align="center" rowSpan={2}>
                      {"Số chuyến bay"}
                    </TableCell>
                    <TableCell style={{ padding: 3, border: "1px solid gray" }} align="center" rowSpan={2}>
                      {"Tỷ trọng thực tế"}
                    </TableCell>
                    <TableCell style={{ padding: 3, border: "1px solid gray" }} align="center" rowSpan={2}>
                      {"Nhiệt độ"} (°C)
                    </TableCell>
                  </>
                )}
                <TableCell style={{ padding: 3, border: "1px solid gray" }} align="center" rowSpan={1} colSpan={3}>
                  {"Số lượng"}
                </TableCell>
                <TableCell style={{ padding: 3, border: "1px solid gray" }} align="center" rowSpan={2}>
                  {`Đơn giá (VNĐ/${ciProduct?.unit || ""})`}
                </TableCell>
                <TableCell style={{ padding: 3, border: "1px solid gray" }} align="center" rowSpan={2}>
                  {"Thành tiền (VNĐ)"}
                </TableCell>
                <TableCell style={{ padding: 3, border: "1px solid gray" }} align="center" rowSpan={2}>
                  VAT {"(VNĐ)"}
                </TableCell>
                <TableCell style={{ padding: 3, border: "1px solid gray" }} align="center" rowSpan={2}>
                  {"Tổng tiền (VNĐ)"}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell style={{ padding: 3, border: "1px solid gray" }} padding="checkbox" align="center">
                  {"Gallon"}
                </TableCell>
                <TableCell style={{ padding: 3, border: "1px solid gray" }} padding="checkbox" align="center">
                  {"Lít TT"}
                </TableCell>
                <TableCell style={{ padding: 3, border: "1px solid gray" }} padding="checkbox" align="center">
                  KG
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {invDetails?.map((item, index) => (
                <TableRow key={index + 1}>
                  <TableCell align="center" style={{ padding: 3, border: "1px solid gray" }}>
                    {index + 1}
                  </TableCell>
                  <TableCell align="center" style={{ padding: 3, border: "1px solid gray" }}>
                    {item.valid_date && moment(item.valid_date).format("DD/MM/YYYY")}
                  </TableCell>
                  <TableCell align="center" style={{ padding: 3, border: "1px solid gray" }}>
                    {item.code}
                  </TableCell>
                  <TableCell align="center" style={{ padding: 3, border: "1px solid gray" }}>
                    {item.fkey}
                  </TableCell>
                  {data.loadingtype_id == 1 && (
                    <>
                      <TableCell align="center" style={{ padding: 3, border: "1px solid gray" }}>
                        {item.code_aircraft}
                      </TableCell>
                      <TableCell align="center" style={{ padding: 3, border: "1px solid gray" }}>
                        {item.route}
                      </TableCell>
                      <TableCell align="center" style={{ padding: 3, border: "1px solid gray" }}>
                        {item.flight_no}
                      </TableCell>
                      <TableCell align="center" style={{ padding: 3, border: "1px solid gray" }}>
                        {item.density == "" ? "-" : (+item.density)?.toLocaleString("de-DE", { minimumFractionDigits: 4, maximumFractionDigits: 4 })}
                      </TableCell>
                      <TableCell align="center" style={{ padding: 3, border: "1px solid gray" }}>
                        {item.temp == "" ? "-" : (+item.temp)?.toLocaleString("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </TableCell>
                    </>
                  )}
                  <TableCell align="right" style={{ padding: 3, border: "1px solid gray" }}>
                    {Math.round(item.sub_gallon)?.toLocaleString("de-DE")}
                  </TableCell>
                  <TableCell align="right" style={{ padding: 3, border: "1px solid gray" }}>
                    {Intl.NumberFormat("de-DE").format(item.sub_lit)}
                  </TableCell>
                  <TableCell align="right" style={{ padding: 3, border: "1px solid gray" }}>
                    {Intl.NumberFormat("de-DE").format(item.sub_kg)}
                  </TableCell>
                  <TableCell align="right" style={{ padding: 3, border: "1px solid gray" }}>
                    {item.price ? Intl.NumberFormat("de-DE").format(item.price) : "-"}
                  </TableCell>
                  <TableCell align="right" style={{ padding: 3, border: "1px solid gray" }}>
                    {Intl.NumberFormat("de-DE").format(item.sub_amount)}
                  </TableCell>
                  <TableCell align="right" style={{ padding: 3, border: "1px solid gray" }}>
                    {item.vat === -1 ? "\\" : Intl.NumberFormat("de-DE").format(item.vat)}
                  </TableCell>
                  <TableCell align="right" style={{ padding: 3, border: "1px solid gray" }}>
                    {Intl.NumberFormat("de-DE").format(item.total)}
                  </TableCell>
                </TableRow>
              ))}
              <TableRow>
                <TableCell style={{ padding: 3, border: "1px solid gray", fontWeight: "bold" }}></TableCell>
                <TableCell style={{ padding: 3, border: "1px solid gray", fontWeight: "bold" }} colSpan={data.loadingtype_id == 1 ? 8 : 3}>
                  {"TỔNG CỘNG"}
                </TableCell>
                <TableCell align="right" style={{ padding: 3, border: "1px solid gray", fontWeight: "bold" }}>
                  {Math.round(sumOfField(invDetails, "sub_gallon"))?.toLocaleString("de-DE")}
                </TableCell>
                <TableCell align="right" style={{ padding: 3, border: "1px solid gray", fontWeight: "bold" }}>
                  {Intl.NumberFormat("de-DE").format(sumOfField(invDetails, "sub_lit"))}
                </TableCell>
                <TableCell align="right" style={{ padding: 3, border: "1px solid gray", fontWeight: "bold" }}>
                  {Intl.NumberFormat("de-DE").format(sumOfField(invDetails, "sub_kg"))}
                </TableCell>
                <TableCell align="right" style={{ padding: 3, border: "1px solid gray", fontWeight: "bold" }}></TableCell>
                <TableCell align="right" style={{ padding: 3, border: "1px solid gray", fontWeight: "bold" }}>
                  {Intl.NumberFormat("de-DE").format(sumOfField(invDetails, "sub_amount"))}
                </TableCell>
                <TableCell align="right" style={{ padding: 3, border: "1px solid gray", fontWeight: "bold" }}>
                  {Intl.NumberFormat("de-DE").format(
                    sumOfField(
                      invDetails?.filter((item) => item.vat > 0),
                      "vat"
                    )
                  )}
                </TableCell>
                <TableCell align="right" style={{ padding: 3, border: "1px solid gray", fontWeight: "bold" }}>
                  {Intl.NumberFormat("de-DE").format(sumOfField(invDetails, "total"))}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </div>
      </div>
    );
  };
  const renderTable = () => {
    return (
      <TableContainer style={{ margin: "15px 0" }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell align="center" style={{ padding: 3, border: "1px solid gray", fontWeight: "bold" }}>
                STT
              </TableCell>
              <TableCell align="center" style={{ padding: 3, border: "1px solid gray", fontWeight: "bold" }}>
                Nơi xuất
              </TableCell>
              <TableCell align="center" style={{ padding: 3, border: "1px solid gray", fontWeight: "bold" }}>
                {t("Loại hình bán")}
              </TableCell>
              {/* <TableCell align='center' style={{ padding: 3, border: '1px solid gray', fontWeight: 'bold' }} >Hình thức tra nạp</TableCell> */}
              <TableCell align="center" style={{ padding: 3, border: "1px solid gray", fontWeight: "bold" }} width="10%">
                Đơn vị tính
              </TableCell>
              <TableCell align="center" style={{ padding: 3, border: "1px solid gray", fontWeight: "bold" }} width="10%">
                Số lượng{" "}
              </TableCell>
              <TableCell align="center" style={{ padding: 3, border: "1px solid gray", fontWeight: "bold" }} width="10%">
                Đơn giá chưa bao gồm VAT
              </TableCell>
              <TableCell align="center" style={{ padding: 3, border: "1px solid gray", fontWeight: "bold" }}>
                Tiền hàng (VNĐ)
              </TableCell>
              <TableCell align="center" style={{ padding: 3, border: "1px solid gray", fontWeight: "bold" }}>
                VAT
              </TableCell>
              <TableCell align="center" style={{ padding: 3, border: "1px solid gray", fontWeight: "bold" }}>
                Tổng tiền (VNĐ)
              </TableCell>
              {Boolean(onCheckbox) && (
                <TableCell rowSpan={2} padding="checkbox" align="center" style={{ padding: 3, border: "1px solid gray", whiteSpace: "nowrap" }}>
                  <Button variant="contained" color="secondary" onClick={onCheckAll}>
                    Chọn tất cả
                  </Button>
                </TableCell>
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.ciproducts.map((product, index) => (
              <TableRow key={index}>
                <TableCell align="center" style={{ padding: 3, border: "1px solid gray" }}>
                  {index + 1}
                </TableCell>
                <TableCell align="center" style={{ padding: 3, border: "1px solid gray" }}>
                  {product.location}
                </TableCell>
                <TableCell align="center" style={{ padding: 3, border: "1px solid gray" }}>
                  {t(product.saletype)}
                </TableCell>
                {/* <TableCell align='center' style={{ padding: 3, border: '1px solid gray' }} >{'___'}</TableCell> */}
                <TableCell align="center" style={{ padding: 3, border: "1px solid gray" }}>
                  {product.unit}
                </TableCell>
                <TableCell align="right" style={{ padding: 3, border: "1px solid gray" }}>
                  {Intl.NumberFormat("de-DE").format(Math.round(product.quantity))}
                </TableCell>
                <TableCell align="right" style={{ padding: 3, border: "1px solid gray" }}>
                  {Intl.NumberFormat("de-DE").format(product.price)}
                </TableCell>
                <TableCell align="right" style={{ padding: 3, border: "1px solid gray" }}>
                  {Intl.NumberFormat("de-DE").format(product.amount)}
                </TableCell>
                <TableCell align="right" style={{ padding: 3, border: "1px solid gray" }}>
                  {product.vat <= 0 ? "\\" : Intl.NumberFormat("de-DE").format(product.vat)}
                </TableCell>
                <TableCell align="right" style={{ padding: 3, border: "1px solid gray" }}>
                  {Intl.NumberFormat("de-DE").format(product.total)}
                </TableCell>
                {Boolean(onCheckbox) && (
                  <TableCell align="center" style={{ padding: 3, border: "1px solid gray", fontWeight: "bold" }}>
                    <Checkbox disabled={product.period == "loading"} checked={product.isCreateBK || false} onChange={(e, value) => onCheckbox(index, value)} />
                  </TableCell>
                )}
              </TableRow>
            ))}
            <TableRow>
              <TableCell align="center" style={{ padding: 3, border: "1px solid gray", fontWeight: "bold" }}></TableCell>
              <TableCell colSpan={3} style={{ padding: 3, border: "1px solid gray", fontWeight: "bold" }}>
                Tổng cộng
              </TableCell>
              <TableCell align="right" style={{ padding: 3, border: "1px solid gray", fontWeight: "bold" }}>
                {Intl.NumberFormat("de-DE").format(Math.round(data?.ciproducts.filter((i) => i.isCreateBK !== false).reduce((p, c) => p + +c.quantity, 0)))}
              </TableCell>
              <TableCell align="center" style={{ padding: 3, border: "1px solid gray", fontWeight: "bold" }}></TableCell>
              <TableCell align="right" style={{ padding: 3, border: "1px solid gray", fontWeight: "bold" }}>
                {Intl.NumberFormat("de-DE").format(Math.round(data?.ciproducts.filter((i) => i.isCreateBK !== false).reduce((p, c) => p + +c.amount, 0)))}
              </TableCell>
              <TableCell align="right" style={{ padding: 3, border: "1px solid gray", fontWeight: "bold" }}>
                {Intl.NumberFormat("de-DE").format(Math.round(data?.ciproducts.filter((i) => i.isCreateBK !== false).reduce((p, c) => p + (c.vat <= 0 ? 0 : +c.vat), 0)))}
              </TableCell>
              <TableCell align="right" style={{ padding: 3, border: "1px solid gray", fontWeight: "bold" }}>
                {Intl.NumberFormat("de-DE").format(Math.round(totalTotal))}
              </TableCell>
              {Boolean(onCheckbox) && <TableCell align="center" style={{ padding: 3, border: "1px solid gray", fontWeight: "bold" }}></TableCell>}
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    );
  };
  return (
    <div style={{ margin: "20px auto", padding: 40 }}>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div style={{}} align="center">
          <img alt="" src="/logoP2.png" width="75px" />
          <div align="left">CTCP NHIÊN LIỆU BAY PETROLIMEX</div>
          {/* <div align='left'>CV số......</div> */}
        </div>
        <div style={{ paddingRight: "5%" }} align="center">
          <span>Cộng hòa Xã hội Chủ nghĩa Việt Nam</span>
          <br />
          <span>Độc lập - Tự do - Hạnh phúc</span>
        </div>
      </div>
      <div align="right">Số: {data.code}</div>
      <div align="right">Ngày: {moment(data.effective_time).format("DD/MM/YYYY")}</div>
      {/* header */}
      <div align="center" style={{ marginBottom: "20px" }}>
        <b style={{ fontSize: 16, margin: "auto", alignContent: "center", textTransform: "uppercase" }}>THÔNG BÁO THU TIỀN HÀNG {data.period}</b>
        <br />
        <i style={{ fontSize: 14, margin: "auto", alignContent: "center" }}>
          (Từ ngày {moment(data.period_start_time).format("DD/MM/YYYY")} đến ngày {moment(data.period_end_time).format("DD/MM/YYYY")})
        </i>
      </div>
      {/* information */}
      <div style={{ alignItems: "flex-start", display: "flex", flexDirection: "column" }}>
        <div>
          Kính gửi: <span style={{ fontWeight: "bold", textTransform: "uppercase" }}>{data.customer?.name}</span>
        </div>
        <div>Địa chỉ: {data.customer?.address}</div>
        <div>MST: {data.customer?.tax_code}</div>
        {/* <div>Số điện thoại: 08.35471866 ; Fax: 08.3 5471865</div> */}
        {/* <div style=> */}
        {ReactHtmlParser(data.note)}
        {/* </div> */}
        <div>Chúng tôi xin trân trọng thông báo chi tiết tiền hàng tới quý khách hàng như sau:</div>
        {renderTable()}
        <div style={{ fontWeight: "bold", text: "" }}>
          <i>Bằng chữ: {numberToStringVN(totalTotal)}</i>
        </div>
        <div>* Kính đề nghị {data.customer.name} thanh toán số tiền trên cho PA chi tiết TK như sau:</div>
        <div style={{ fontWeight: "bold", paddingLeft: 200 }}>Người thụ hưởng : {data.bact?.act_holder}</div>
        <div style={{ fontWeight: "bold", paddingLeft: 200 }}>TK số: {data.bact?.act_number}</div>
        <div style={{ fontWeight: "bold", paddingLeft: 200 }}>Tại {data.bact?.bank_code}</div>
        <div style={{ fontWeight: "bold" }}>
          <i style={{ textDecoration: "underline" }}>* Thời hạn thanh toán: Ngày {data.end_effective_time && moment(data.end_effective_time).format("DD/MM/YYYY")}</i>
        </div>
        <div style={{ display: "flex", width: "100%", marginTop: "15px" }}>
          <div style={{ width: "50%", textAlign: "start" }}>
            <i style={{ fontWeight: "bold", textDecoration: "underline" }}>Nơi nhận:</i>
            <div>- Như kính gửi,</div>
            <div>- Phòng KD Cty,</div>
            <div>- Lưu TC-KT.</div>
          </div>
          <div style={{ width: "50%" }} align="center">
            <b>CTY CP NHIÊN LIỆU BAY PETROLIMEX</b>
          </div>
        </div>
      </div>
      <div style={{ margin: 20, pageBreakAfter: "always" }} />

      <div align="center" style={{ pageBreakInside: "auto" }}>
        <b style={{ fontSize: 16, margin: "auto", alignContent: "center", textTransform: "uppercase" }}>BẢNG KÊ CHI TIẾT XUẤT BÁN</b>
        <br />
        <i style={{ fontSize: 14, margin: "auto", alignContent: "center" }}>
          (Từ ngày {moment(data.period_start_time).format("DD/MM/YYYY")} đến ngày {moment(data.period_end_time).format("DD/MM/YYYY")})
        </i>
      </div>
      <div>
        {data?.ciproducts.map((item, index) =>
          item.isCreateBK !== false ? (
            renderUpLift(
              index + 1,
              item,
              data?.invoices?.filter((invoice) => item.invoices.includes(invoice.id))
            )
          ) : (
            <></>
          )
        )}
      </div>
    </div>
  );
}
